import { mapGetters } from 'vuex';
import mvtOverlay from '@/common/components/mvtoverlay/mvt-overlay.vue';
import dppHotleadButton from '@/dpp/components/dpphotleadbutton/dpp-hotleadbutton.vue';
import dppButton from '@/dpp/components/propertybutton/dpp-button/dpp-button.vue';
import { loadImg as nativeLoadImg } from '@/common/utilities/nojq/_load.img.js';
import { router } from '../../../common/utilities/nojq/_router.js';

function loadImg(imgElement) {
    const imgEl = imgElement;
    const imgSrc = imgEl.getAttribute('data-src');
    if (imgSrc) {
        nativeLoadImg(imgEl, imgSrc);
    }
    imgEl.removeAttribute('data-src');
}
export default {
    name: 'propertyPop',
    inject: ['$eventBus'],
    components: {
        mvtOverlay,
        dppHotleadButton,
        dppButton,
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getSplit']),
        ...mapGetters('dpp', ['dpp']),
    },
    data() {
        return {
            observer: null,
        };
    },
    methods: {
        open() {
            this.$eventBus.$emit('eventbus-property-pop-open', this.$options);
            this.$refs.overlay.show();
            this.$emit('show');
            router.add(this.$options.name);
            setTimeout(() => {
                this.$eventBus.$once('eventbus-property-pop-open', this.hide);
            }, 100);
        },
        close() {
            this.hide();

            router.back(this.$options.name);
        },
        hide() {
            if (this.$refs.overlay.isActive) {
                this.$emit('hide');
            }
            this.$refs.overlay.hide();
            this.$eventBus.$emit('eventbus-property-pop-close', this.$options);
        },
        showHotlead() {
            var hotleadOpt = {
                hotleadType: 'PhotoViewHotleadInResponsiveDPP',
                propertyId: this.dpp.propertyId,
                propertyData: this.dpp,
                showComment: false,
            };
            if (this.glb.agent.id) {
                hotleadOpt.ojoFormConfigs = {
                    showCtaLinks: false,
                    showOJOagentInfo: true,
                    showDisclaimer: false,
                    commnetLabel: 'Message',
                };
            }
            this.$eventBus.$emit('dialog-center', { name: 'mvtHotleadForm', trigger: this.$options.name, opt: hotleadOpt });
        },
        refresh() {
            var that = this;
            var $scroller = $(this.$refs['scroller']);
            if ($scroller.find('.property-pop-scroller').length) {
                $scroller = $scroller.find('.property-pop-scroller');
            }
            $scroller.find('[data-src]').each(function (i, e) {
                that.setImg(e, $scroller[0]);
            });
        },
        setImg(img, scroller) {
            var that = this;
            if (window.IntersectionObserver) {
                if (!this.observer) {
                    const options = {
                        root: scroller,
                        rootMargin: '100% 0% 100% 0%',
                        threshold: 0,
                    };
                    this.observer = new IntersectionObserver(function (entries) {
                        entries.forEach((entry) => {
                            if (!entry.isIntersecting) {
                                return;
                            }
                            loadImg(entry.target);
                            that.observer.unobserve(entry.target);
                        });
                    }, options);
                }
                this.observer.observe(img);
            } else {
                loadImg(img);
            }
        },
    },
    mounted() {
        var that = this;
        setTimeout(function () {
            that.refresh();
        }, 10);
        $(document).on('dom.key.esc.' + this.vnumber, this.close);
        $(document).on('dom.popstate.' + this.vnumber, function (e, key) {
            if (!key || key !== that.$options.name) {
                that.hide();
            }
        });
    },
    beforeUnmount() {
        $(document).off('dom.key.esc.' + this.vnumber);
        $(document).off('dom.popstate.' + this.vnumber);
    },
};
